import { Directive, HostBinding, HostListener, Output, EventEmitter } from '@angular/core';
@Directive({
  selector: '[aems-drag-drop]',
  standalone: true,
})
export class DragDropDirective {
  @Output() fileDropped = new EventEmitter<FileList>();
  private cssClass = 'aems-file-upload-drag-drop';
  @HostBinding('class') get hostClass(): string {
    return this.cssClass;
  }
  @HostListener('dragover', ['$event']) onDragOver(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.cssClass = 'drag';
  }
  @HostListener('dragleave', ['$event']) public onDragLeave(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.cssClass = 'aems-file-upload-drag-drop';
  }
  @HostListener('drop', ['$event']) public onDrop(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.cssClass = 'aems-file-upload-drag-drop';
    const files = event.dataTransfer?.files;
    if (files) {
      this.fileDropped.emit(files);
    }
  }
}
